import { Instagram, Youtube, MessageCircle } from "lucide-react";
import { Link } from "react-router-dom";
import { LOGO_URL, INSTAGRAM_URL, YOUTUBE_URL, WHATSAPP_URL, NAV_LINKS } from "./constants";

export const Footer = ({ scrollTo }) => (
  <footer
    className="relative z-10 border-t border-white/10 px-6 pt-16 pb-10"
    data-testid="footer"
  >
    <div className="mx-auto max-w-7xl">
      <div className="grid grid-cols-1 gap-12 md:grid-cols-12">
        {/* Brand */}
        <div className="md:col-span-5">
          <img
            src={LOGO_URL}
            alt="DUNC"
            className="dunc-logo-invert h-7 w-auto"
            width="140"
            height="30"
          />
          <p className="mt-6 max-w-sm text-sm leading-relaxed text-[#CFC6BC]">
            DUNC is a modern, sparkling kombucha brand from India. Bold flavours,
            slow fermentation, no shortcuts.
          </p>
          <p className="mt-6 text-[11px] uppercase tracking-[0.32em] text-[#8C8177]" data-testid="footer-crafted">
            Crafted in India
          </p>
        </div>

        {/* Explore */}
        <div className="md:col-span-3">
          <p className="mb-5 text-[11px] uppercase tracking-[0.32em] text-[#8C8177]">Explore</p>
          <ul className="space-y-3">
            {NAV_LINKS.map((l) => (
              <li key={l.href}>
                {l.href.startsWith("/") ? (
                  <Link
                    to={l.href}
                    className="text-sm text-[#F5EFE6] transition-colors hover:text-[#D9A441]"
                    data-testid={`footer-${l.label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                  >
                    {l.label}
                  </Link>
                ) : (
                  <button
                    onClick={() => scrollTo && scrollTo(l.href)}
                    className="text-sm text-[#F5EFE6] transition-colors hover:text-[#D9A441]"
                    data-testid={`footer-${l.label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                  >
                    {l.label}
                  </button>
                )}
              </li>
            ))}
            <li>
              <button
                onClick={() => scrollTo && scrollTo("#dunc-list")}
                className="text-sm text-[#F5EFE6] transition-colors hover:text-[#D9A441]"
                data-testid="footer-dunc-list"
              >
                DUNC List
              </button>
            </li>
          </ul>
        </div>

        {/* Legal */}
        <div className="md:col-span-2">
          <p className="mb-5 text-[11px] uppercase tracking-[0.32em] text-[#8C8177]">Legal</p>
          <ul className="space-y-3">
            <li><Link to="/privacy" className="text-sm text-[#F5EFE6] hover:text-[#D9A441]" data-testid="footer-privacy">Privacy Policy</Link></li>
            <li><Link to="/terms" className="text-sm text-[#F5EFE6] hover:text-[#D9A441]" data-testid="footer-terms">Terms</Link></li>
            <li><Link to="/contact" className="text-sm text-[#F5EFE6] hover:text-[#D9A441]">Contact</Link></li>
          </ul>
        </div>

        {/* Social */}
        <div className="md:col-span-2">
          <p className="mb-5 text-[11px] uppercase tracking-[0.32em] text-[#8C8177]">Social</p>
          <div className="flex items-center gap-3">
            <a
              href={INSTAGRAM_URL}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
              data-testid="footer-instagram"
              className="flex h-11 w-11 items-center justify-center rounded-full border border-white/12 text-[#CFC6BC] transition-colors hover:border-[#D9A441]/60 hover:text-[#D9A441]"
            >
              <Instagram className="h-5 w-5" />
            </a>
            <a
              href={YOUTUBE_URL}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="YouTube"
              data-testid="footer-youtube"
              className="flex h-11 w-11 items-center justify-center rounded-full border border-white/12 text-[#CFC6BC] transition-colors hover:border-[#D9A441]/60 hover:text-[#D9A441]"
            >
              <Youtube className="h-5 w-5" />
            </a>
            <a
              href={WHATSAPP_URL()}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="WhatsApp"
              data-testid="footer-whatsapp"
              className="flex h-11 w-11 items-center justify-center rounded-full border border-white/12 text-[#CFC6BC] transition-colors hover:border-[#D9A441]/60 hover:text-[#D9A441]"
            >
              <MessageCircle className="h-5 w-5" />
            </a>
          </div>
        </div>
      </div>

      <div className="mt-14 border-t border-white/5 pt-6 flex flex-col items-center gap-2 text-center md:flex-row md:justify-between md:text-left">
        <p className="text-xs text-[#6b6055]">
          © {new Date().getFullYear()} DUNC™. All rights reserved. ·{" "}
          <span data-testid="footer-owner">Brand owned by Magnapex Group LLP</span>
        </p>
        <p className="text-xs text-[#D9A441]/80" data-testid="footer-ecommerce-note">
          Note: We're launching our online store soon.
        </p>
        <p className="text-xs text-[#6b6055]">drinkdunc.com</p>
      </div>
    </div>
  </footer>
);

export default Footer;
